<template>
  <div id="app" :style="style">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { FLIPOVER_LANGUAGE } from '@/utils';
  import { closeWebView, LOCALE } from '@similar/utils-tools';

  @Component({})
  export default class index extends Vue {
    style = '';

    created() {
      // 用户协议不用镜像
      if (
        LOCALE === FLIPOVER_LANGUAGE &&
        !window.location.hash.includes('user-policy') &&
        !window.location.hash.includes('sud-client')
      ) {
        this.style = `transform: scaleX(-1);text-align: right;`;
      }

      window.clickBack = () => {
        closeWebView();
      };
    }
  }
</script>

<style lang="scss">
  * {
    font-family: 'Aktiv Grotesk Trial';
  }
</style>
